const styles = () => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },

  body: {
    flex: '1 0 auto',
    background: '#fafbfc',
  },

  field: {
    margin: '30px',
  },

  contactInfo: {
    borderBottom: '1px solid #e1e6eb',
    display: 'flex',
  },

  planOptions: {
    padding: '30px',
    borderBottom: '1px solid #e1e6eb',
  },

  choosePlan: {
    margin: '0px 0px 20px',
  },

  planOption: {
    display: 'flex',
    margin: '10px 0px',
  },

  checkbox: {
    marginRight: '20px',
    padding: 0,
    alignItems: 'baseline',
  },

  optionName: {
    color: '27282a',
    fontWeight: 500,
    marginBottom: '5px',
  },

  optionDescription: {
    color: '#596168',
    margin: 0,
  },

  message: {
    display: 'flex',
  },
});

export default styles;
